<template>
  <div id="trivia">
    <section class="bannerprincipal">
      <SiteNav v-if="showNav"></SiteNav>
      <div
        v-if="!showNav"
        class="col-12 text-center"
        data-aos="fade-down"
        data-aos-delay="100"
      >
        <!-- <router-link to="/">
          <img
            class="pt-5 img-fluid"
            src="../assets/imgs/homecapistrano/texto-1.png"
            alt="Copa Prosa"
          />
        </router-link> -->
      </div>

      <div class=""></div>
    </section>

    <section class="pt-5 mt-5">
      <div class="container pt-2 mt-5">
        <div class="row pt-5">
          <div class="col-12">
            <div class="py-t justified negro">
              <h1 style="text-align: center" class="pb-4">
                <strong>Aviso de Privacidad Integral</strong>
              </h1>
              <div>
                <p>
                  Para Promoción y Operación S.A. de C.V. (PROSA) es muy
                  importante mantener la privacidad y confianza de sus Clientes,
                  con el propósito de asegurar que se conozca cómo
                  salvaguardamos la integridad, privacidad y protección de sus
                  datos personales, le damos a conocer el Aviso de Privacidad
                  Integral para Clientes, en apego a la Ley Federal de
                  Protección de Datos Personales en Posesión de los Particulares
                  (en adelante referida como “la Ley”) y su Reglamento, por lo
                  que solicitamos lea atentamente la siguiente información:
                </p>
              </div>
              <div>
                <p>1.- IDENTIDAD Y DOMICILIO DEL RESPONSABLE</p>
              </div>
              <div>
                <p>
                  Promoción y Operación S.A. de C.V. (en adelante “El
                  Responsable”) declara ser una empresa legalmente constituida
                  de conformidad con las leyes mexicanas, con domicilio el
                  ubicado en Bahía de Chachalacas #7, Colonia Verónica Anzures,
                  Alcaldía de Miguel Hidalgo, C.P. 11300, Ciudad de México.
                </p>
              </div>
              <div>
                <p>
                  Para solicitudes e información, se cuenta con un servicio de
                  atención, en el número telefónico (55) 55 5268-1515 en un
                  horario de 9:00 a 18:00 hrs. de lunes a viernes, así como el
                  correo electrónico asc@prosa.com.mx
                </p>
              </div>
              <div>
                <p>
                  Nuestro Aviso de Privacidad Integral para Clientes se podrá
                  consultar en el portal de internet:
                  <a href="https://www.prosamexico.mx/">
                    https://www.prosamexico.mx
                  </a>
                  , <a href="https://www.carnet.mx/">https://www.carnet.mx</a>,
                  <a href="https://www.promocionesmsi.com.mx/">
                    https://www.promocionesmsi.com.mx
                  </a>
                  y
                  <a href="https://www.academiaprosa.com.mx/">
                    https://www.academiaprosa.com.mx
                  </a>
                </p>
              </div>
              <div>
                <p>2.- DATOS PERSONALES</p>
              </div>
              <div>
                <p>
                  El Responsable podrá recabar sus datos personales de manera
                  directa o indirecta mediante el uso de medios remotos de
                  comunicación electrónica, óptica u otra tecnología que
                  permitan recabar sus datos personales de manera automática y
                  simultánea. Para el cumplimiento y consecución de las
                  finalidades por las que se obtienen y se recaban los datos
                  personales, se le informa que se podrán recabar todas o
                  algunas de las siguientes categorías de datos personales:
                </p>
              </div>
              <div>
                <p>3.- DATOS SENSIBLES</p>
              </div>
              <div>
                <p>
                  Se le informa que El Responsable no recabará datos personales
                  sensibles, se consideran “datos sensibles” aquellos datos
                  personales que afecten a la esfera más íntima de su Titular, o
                  cuya utilización indebida pueda dar origen a discriminación o
                  conlleve un riesgo grave para éste. En particular, se
                  consideran datos sensibles, aquellos que puedan revelar
                  aspectos como origen racial o étnico, estado de salud presente
                  y futura, información genética, creencias religiosas,
                  filosóficas y morales, afiliación sindical, opiniones
                  políticas, preferencia sexual.
                </p>
              </div>
              <div>
                <p>4.- FINALIDADES DEL TRATAMIENTO DE DATOS</p>
              </div>
              <div>
                <p>
                  El Responsable tratará sus datos personales para las
                  siguientes finalidades primarias (las cuáles dan origen a la
                  relación contractual y son necesarias para la existencia,
                  mantenimiento y cumplimiento de la relación jurídica entre El
                  Responsable y el Titular de los datos personales), por lo que
                  el Titular autoriza al El Responsable a utilizar sus datos
                  personales para las siguientes finalidades Primarias:
                </p>
              </div>
              <div>
                <p>
                  • Administrar y operar los servicios y/o productos que
                  solicita o contrata el Titular con el Responsable. •
                  Consultas, investigaciones y/o revisiones, para atender
                  cualquier queja, reclamación o aclaración que se reciba por
                  parte de los Titulares. • Dar cumplimiento a las obligaciones
                  contractuales contraídas por el Titular con el Responsable y
                  en su caso con sus subsidiarias. • Formalizar y registrar la
                  contratación de un producto y/o servicio. • Identificación y
                  conocimiento de los Titulares cuando actúan con el carácter de
                  clientes, validación de su identidad y registro de sus datos
                  para efectos de identificación del producto y/o servicio
                  contratado con El Responsable. • Informar a los Titulares que
                  actúan con el carácter de clientes, sobre cambios en los
                  productos y/o servicios contratados con El Responsable. •
                  Notificaciones sobre cambios en condiciones de uso de los
                  productos y/o servicios contratados por el Titular. •
                  Operación y registro de los productos y/o servicios
                  contratados por el Titular. • Atención de requerimientos de
                  cualquier autoridad competente conforme a la legislación
                  aplicable a las entidades financieras.
                </p>
              </div>
              <div>
                <p>
                  Al término de la relación contractual, los datos personales
                  recabados se utilizarán y resguardarán para los fines
                  exclusivos establecidos en las Leyes aplicables.
                </p>
              </div>
              <div>
                <p>
                  Asimismo, si no se manifiesta lo contrario, El Responsable
                  tratará sus datos personales para las siguientes finalidades
                  secundarias.
                </p>
              </div>
              <div>
                <p>
                  Los datos personales que El Responsable recaba tienen la
                  finalidad secundaria de:
                </p>
              </div>
              <div>
                <p>
                  *Realizar estudios de mercado. *Información estadística
                  referente al uso de los productos y/o servicios contratados
                  por el Titular. *Informar sobre nuevos productos y/o servicios
                  que estén relacionados con lo contratado o adquirido por el
                  Titular.
                </p>
              </div>
              <div>
                <p>
                  5.- MECANISMOS PARA QUE PUEDA MANISFESTAR SU NEGATIVA PREVIA
                  AL TRATAMIENTO DE LOS DATOS PERSONALES.
                </p>
              </div>
              <div>
                <p>
                  En caso de que el Aviso de Privacidad no sea dado a conocer al
                  Titular de manera directa o personal, éste tendrá un plazo de
                  cinco días hábiles conforme a lo que establece la Ley, para
                  manifestar su oposición en el tratamiento de sus datos
                  personales para finalidades que no son necesarias, ni dieron
                  origen a la relación jurídica o contractual entre El
                  Responsable y el Titular, conforme al procedimiento de los
                  medios para ejercer los derechos ARCO señalado en el presente
                  Aviso de Privacidad.
                </p>
              </div>
              <div>
                <p>6.- TRANSFERENCIA DE DATOS PERSONALES</p>
              </div>
              <div>
                <p>
                  Con el propósito de dar cumplimiento a las obligaciones
                  derivadas de la relación jurídica, El Responsable requiere
                  transferir sus datos personales, al interior y fuera del
                  territorio nacional, así como también, se compromete a velar
                  por que se cumplan todos los principios legales de protección
                  de datos personales derivados de la transferencia de sus datos
                  personales y asegurar el cumplimiento en todo momento del
                  presente Aviso de Privacidad.
                </p>
              </div>
              <div>
                <p>
                  Por lo que El Responsable podrá transferir, comunicar y/o
                  tratar los datos personales del Titular dentro y fuera del
                  país, a terceros como son: 1) Sociedad subsidiarias, afiliadas
                  o que formen parte del mismo grupo de El Responsable, 2)
                  Reguladores, 3) Patrocinadores, socios comerciales o de
                  negocio que ofrezcan productos o que presten algún servicio a
                  El Responsable.
                </p>
              </div>
              <div>
                <p>
                  Adicionalmente El Responsable podrá transferir los datos
                  personales del Titular, si alguna Ley así lo exige, o bien,
                  cuando así lo soliciten autoridades competentes en términos de
                  la legislación aplicable.
                </p>
              </div>
              <div>
                <p>
                  Sin perjuicio de lo anterior, El Responsable velará por el
                  cumplimiento de los principios de protección de datos
                  personales establecidos en la Ley, adoptando las medidas
                  necesarias para su aplicación, así como a exigir su
                  cumplimiento a las personas físicas o morales a los que se
                  lleguen a transferir los datos personales cuya finalidad
                  prevista para la transferencia de sus datos personales son
                  motivadas para el cumplimiento de la relación jurídica entre
                  El Responsable y los Titulares.
                </p>
              </div>
              <div>
                <p>
                  7. CONSENTIMIENTO PARA LA TRANSFERENCIA DE DATOS PERSONALES.
                </p>
              </div>
              <div>
                <p>
                  Con la aceptación del presente Aviso de Privacidad, el Titular
                  otorga su consentimiento y aceptación para que El Responsable
                  transfiera sus datos personales a terceros nacionales o
                  extranjeros conforme a lo previsto en el numeral seis del
                  presente Aviso de Privacidad.
                </p>
              </div>
              <div>
                <p>
                  8.- MEDIOS PARA EJERCER LOS DERECHOS ARCO (ACCESO,
                  RECTIFICACIÓN, CANCELACIÓN U OPOSICIÓN).
                </p>
              </div>
              <div>
                <p>
                  Tiene derecho a conocer qué datos personales tenemos de usted,
                  para qué los utilizamos y las condiciones del uso que les
                  damos (“Acceso”). Asimismo, es su derecho solicitar la
                  corrección de su información personal en caso de que esté
                  desactualizada, sea inexacta o incompleta (“Rectificación”);
                  que eliminemos de nuestros registros o bases de datos cuando
                  considere que la misma no está siendo utilizada adecuadamente
                  (“Cancelación”); así como oponerse al uso de sus datos
                  personales para fines específicos (“Oposición”). Estos
                  derechos se conocen como Derechos ARCO.
                </p>
              </div>
              <div>
                <p>
                  Para el ejercicio de cualquiera de los Derechos ARCO, deberá
                  seguir el siguiente procedimiento y reunir los requisitos
                  mencionados:
                </p>
              </div>
              <div>
                <p>
                  El Titular contará con 10 días hábiles para atender el
                  requerimiento, contados a partir del día siguiente en que lo
                  haya recibido. De no dar respuesta en dicho plazo, se tendrá
                  por no presentada la solicitud correspondiente. En caso de que
                  el Titular atienda el requerimiento de información, el plazo
                  de respuesta a la solicitud empezará a correr al día siguiente
                  de que el Titular haya atendido el requerimiento (Es decir,
                  los 15 días hábiles restantes).
                </p>
              </div>
              <div>
                <p>
                  En cada etapa del procedimiento el Titular recibirá un acuse
                  de recibo por parte de El Responsable, con la fecha
                  correspondiente.
                </p>
              </div>
              <div>
                <p>
                  La resolución adoptada por El Responsable será comunicada al
                  Titular a través de las opciones elegidas por éste, las cuales
                  se deberán indicar en el “formato”.
                </p>
              </div>
              <div>
                <p>9.- MECANISMOS PARA QUE PUEDA MANIFESTAR SU REVOCACIÓN</p>
              </div>
              <div>
                <p>
                  En los casos en que el Titular desee revocar la autorización
                  otorgada a El Responsable, respecto de los datos personales
                  proporcionados, deberá realizar la solicitud correspondiente
                  en los mismos términos establecidos en el presente Aviso de
                  Privacidad para ejercer su Derecho ARCO.
                </p>
              </div>
              <div>
                <p>10.- LIMITACIÓN DE USO O DIVULGACIÓN</p>
              </div>
              <div>
                <p>
                  El Responsable no usa o divulga información para fines
                  distintos a los mencionados en el presente Aviso de
                  Privacidad.
                </p>
              </div>
              <div>
                <p>
                  Para limitar el uso o divulgación de sus datos personales, El
                  Responsable ha instrumentado medidas de seguridad de carácter
                  administrativo, físico y técnico con el objeto de evitar mal
                  uso y la divulgación de los datos personales. En cualquier
                  momento el Titular podrá iniciar el procedimiento para limitar
                  el tratamiento de sus datos personales, debiendo seguir el
                  procedimiento previsto en el numeral nueve del presente Aviso
                  de Privacidad.
                </p>
              </div>
              <div>
                <p>
                  Adicionalmente, con el objeto de que pueda limitar el uso y
                  divulgación de su información personal, lo puede hacer por
                  medio de la inscripción en el “Registro Público para Evitar
                  Publicidad” (REPEP), que está a cargo de la Procuraduría
                  Federal del Consumidor, con la finalidad de que sus datos
                  personales no sean utilizados para recibir publicidad o
                  promociones de empresas de bienes o servicios.
                </p>
              </div>
              <div>
                <p>
                  Para más información sobre este registro, puede consultar el
                  portal de Internet de la PROFECO, o bien ponerse en contacto
                  directo con ésta.
                </p>
              </div>
              <div>
                <p>11.- NUESTRO PORTAL DE INTERNET</p>
              </div>
              <div>
                <p>
                  Los portales de El Responsable se utilizan principalmente para
                  cubrir los siguientes propósitos:
                </p>
              </div>
              <div>
                <p>
                  (i) Facilitar el acceso a los servicios de El Responsable.
                </p>
              </div>
              <div>
                <p>
                  (ii) Publicar y dar a conocer su Aviso de Privacidad integral.
                </p>
              </div>
              <div>
                <p>
                  Al acceder a los portales de El Responsable, se establece una
                  sesión segura mediante el protocolo SSL (Secure Socket Layer)
                  que nos permite que toda la información que viaje desde
                  nuestros servidores hacia su terminal y viceversa se mantenga
                  protegida contra acceso indebido.
                </p>
              </div>
              <div>
                <p>
                  Los portales de El Responsable y sus diferentes sitios de
                  internet a los que se enlaza se basan en el manejo de Cookies
                  y/o Web Beacons que exclusivamente se utilizan para mejorar la
                  experiencia de navegación, medir nuestra audiencia y mostrar
                  contenido basado en la interacción de la página.
                </p>
              </div>
              <div>
                <p>12.-RESOLUCIÓN DE CONTROVERSIAS</p>
              </div>
              <div>
                <p>
                  Le informamos que la autoridad competente para resolver
                  cualquier conflicto derivado de
                </p>
              </div>
              <div>
                <p>
                  la aplicación de la Ley y su Reglamento es el Instituto
                  Nacional de Transparencia, Acceso a
                </p>
              </div>
              <div>
                <p>
                  la Información y Protección de Datos Personales (INAI) para
                  mayor información visite www.inai.org.mx
                </p>
              </div>
              <div>
                <p>13.- CAMBIOS AL AVISO DE PRIVACIDAD</p>
              </div>
              <div>
                <p>
                  Nos reservamos el derecho de efectuar en cualquier momento
                  modificaciones o actualizaciones al presente Aviso de
                  Privacidad, para la atención de reformas a la Leyes
                  aplicables, políticas internas o nuevos requerimientos para la
                  prestación u ofrecimiento de nuestros productos o servicios.
                </p>
              </div>
              <div>
                <p>
                  Por lo que podrá consultar y estar informado de las
                  actualizaciones al Aviso de Privacidad integral para Clientes,
                  ingresando a los portales https://www.prosamexico.mx,
                  https://carnet.mx y https://promocionesmsi.com.mx y
                  https://www.academiaprosa.com.mx
                </p>
              </div>
              <div>
                <p>
                  Fecha de última actualización del presente Aviso de
                  Privacidad: 6 de mayo de 2024.
                </p>
              </div>
            </div>
          </div>

          <div class="col-12 py-5"></div>
          <div class="col-12 py-5"></div>
        
          
        </div>
      </div>
    </section>

    <FooterTerminos></FooterTerminos>
  </div>
</template>

<script>
import SiteNav from "@/components/SiteNavInterior";
import swal from "sweetalert2";

import FooterTerminos from "@/components/FooterTerminos";

export default {
  components: {
    FooterTerminos,
    SiteNav,
  },
  data() {
    return {};
  },
  computed: {
    showNav() {
      //return Object.keys(this.userProfile).length > 1;
      return true;
    },
  },
  mounted: function () {},
};
</script>

<style lang="scss" scoped>
ul {
  li {
    list-style: none;
  }
}
table {
  margin: 0 auto !important;
  border: 1px solid #afafaf;
}
</style>
